"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var StatusCircle = function StatusCircle(_ref) {
  var variant = _ref.variant;
  return (0, _preact.h)("div", {
    className: "status-circle ".concat(variant ? "status-circle--".concat(variant) : 'status-circle--default')
  });
};

var _default = StatusCircle;
exports.default = _default;